import { Button } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const LinkButton = styled(Button)`
  text-transform: none !important;
  font-size: 1rem !important;
`;

function ReturnButton({ path }) {
  const navigate = useNavigate();

  return <LinkButton onClick={() => navigate(path ?? -1)}>Return</LinkButton>;
}

ReturnButton.propTypes = {
  path: PropTypes.string,
};

ReturnButton.defaultProps = {
  path: undefined,
};

export default ReturnButton;
